import { createContext, useContext, useState, type ReactNode } from 'react';
import { translations, type Translations, type Locale } from './translations';

interface LanguageContextValue {
  t: Translations;
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  t: translations.en,
  locale: 'en',
  setLocale: () => {},
});

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [locale, setLocale] = useState<Locale>('en');

  return (
    <LanguageContext.Provider value={{ t: translations[locale], locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}
